import { Pole } from '../types/content';

export const poles: Pole[] = [
  {
    id: 'bureau-etudes',
    name: 'Bureau d’études 3D',
    description:
      'Modélisation, découpage en modules, plans d’exécution et notes de calcul — avant la première découpe.',
    machines: ['Rhino · SolidWorks', 'Import STEP / OBJ', 'Plans d’exécution'],
    file: 'tete_monumentale_v12.step',
  },
  {
    id: 'usinage',
    name: 'Usinage robot & CNC',
    description: 'Sculpture de blocs de polystyrène densifié jusqu’à 6 m et usinage bois ou composites.',
    machines: ['Robot 5 axes', 'Fraiseuse CNC 4 × 2 m'],
    file: 'usinage_passe_finition.nc',
  },
  {
    id: 'metallerie',
    name: 'Métallerie & découpe plasma',
    description: 'Ossatures acier, platines, châssis de tournée et structures autoportantes.',
    machines: ['Table plasma 6 × 2 m', 'Postes MIG / TIG'],
    file: 'chassis_tournee_acier.dxf',
  },
  {
    id: 'resine',
    name: 'Projection résine Polyspray',
    description: 'Peau polyurée projetée : rigidité, légèreté, tenue extérieure et classement feu.',
    machines: ['Bi-composant haute pression', 'Cabine 12 m'],
    file: 'peau_polyuree_3mm.obj',
  },
  {
    id: 'finitions',
    name: 'Finitions & assemblage',
    description: 'Peinture, patines, intégration lumière et pré-montage complet avant le départ.',
    machines: ['Cabine peinture', 'Hall de pré-montage 900 m²'],
    file: 'assemblage_final.pdf',
  },
];
